import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";

@Injectable({
	providedIn: "root"
})
export class UserService {
	constructor(
		private http: HttpService
	) { }

	updateUser(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/updateUser", true, data).then(res => {
				resolve(res);
			}).catch(err => reject(err));
		});
	}

	getAll(data: any = {}) {
		return new Promise((resolve, reject) => {
			this.http.get("api/users/users/getAll/?" + Object.entries(data).map(e => e.join("=")).join("&"), true).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	updateConfig(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/updateUserInfo", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}

	updatePassword(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/updatePassword", true, data).then(res => {
				resolve(res);
			}).catch(err => reject(err));
		});
	}

	profileAvatar(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/profileAvatar", true, data).then(res => {
				resolve(res);
			}).catch(err => reject(err));
		});
	}

	profileDocs(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/uploadDocs", true, data).then(res => {
				resolve(res);
			}).catch(err => reject(err));
		});
	}

	resetPassword(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/resetPassword", true, data).then(res => {
				resolve(res);
			}).catch(err => reject(err));
		});
	}
	uploadFileUser(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/uploadFileUser", false, data).then(res => {
				resolve(res);
			}).catch(err => reject(err));
		});
	}

}
